import { render, staticRenderFns } from "./rewards-summary.vue?vue&type=template&id=926b1e32&scoped=true&lang=pug&"
import script from "./rewards-summary.vue?vue&type=script&lang=ts&"
export * from "./rewards-summary.vue?vue&type=script&lang=ts&"
import style0 from "./rewards-summary.vue?vue&type=style&index=0&id=926b1e32&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "926b1e32",
  null
  
)

export default component.exports